import { render, staticRenderFns } from "./ModalGlobal.vue?vue&type=template&id=81239d52&scoped=true&"
import script from "./ModalGlobal.vue?vue&type=script&lang=js&"
export * from "./ModalGlobal.vue?vue&type=script&lang=js&"
import style0 from "./ModalGlobal.vue?vue&type=style&index=0&id=81239d52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81239d52",
  null
  
)

export default component.exports